import React from 'react';
import PropTypes from 'prop-types';
import DateField from './DateField';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledDiv = styledComponent('div', {
  '& .date-range-row': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.gapXl,
    flexWrap: 'wrap',
  },
  '& .date-range-field': {
    flex: '1 1 auto',
    minWidth: 0,
  },
  '& .date-range-separator': {
    ...theme.typography.body,
    color: theme.colors.textMuted,
  },
  '& .date-range-error': {
    ...theme.typography.hint,
    color: theme.colors.danger,
    marginTop: theme.spacing.labelGap,
  },
  [`@media (max-width: ${theme.breakpoints.mobile})`]: {
    '& .date-range-field': {
      flexBasis: '100%',
    },
    '& .date-range-separator': {
      display: 'none',
    },
  },
});

function DateRangeField({
  startValue,
  endValue,
  onStartChange,
  onEndChange,
  minDate,
  error,
  disabled,
}) {
  return (
    <StyledDiv>
      <div className="date-range-row">
        <div className="date-range-field">
          <DateField
            value={startValue}
            onChange={onStartChange}
            minDate={minDate}
            disabled={disabled}
          />
        </div>
        <span className="date-range-separator" aria-hidden="true">
          to
        </span>
        <div className="date-range-field">
          <DateField
            value={endValue}
            onChange={onEndChange}
            minDate={minDate}
            disabled={disabled}
          />
        </div>
      </div>
      {error && <div className="date-range-error">{error}</div>}
    </StyledDiv>
  );
}

DateRangeField.propTypes = {
  startValue: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  endValue: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
  minDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.oneOf([null]),
  ]),
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

DateRangeField.defaultProps = {
  startValue: null,
  endValue: null,
  minDate: undefined,
  error: undefined,
  disabled: false,
};

export default DateRangeField;
